import { ComponentType } from '../types/component-type'
import { http } from '../services/http'
export const fetchComponentTypes = async (): Promise<Array<ComponentType>> => {
  const response = await http.get<Array<ComponentType>>('/v2/admin/component-types')
  return response.data
}
